import Certificate from '@berlitzplatforms/micro.ui.certificate'
import { ICertData } from '@interfaces/Achievements'
import * as React from 'react'
import { useIntl } from 'react-intl'

const CertificateItem: React.FC<{ cert: ICertData; loading?: boolean }> = ({ cert, loading }) => {
  const intl = useIntl()

  return (
    <Certificate
      type={cert.type ? intl.formatMessage({ id: cert.type, defaultMessage: cert.type }) : ''}
      templateName={
        cert.templateName ? intl.formatMessage({ id: cert.templateName, defaultMessage: cert.templateName }) : ''
      }
      description1={
        cert.description1
          ? intl.formatMessage({
              id: cert.description1,
              defaultMessage: cert.description1,
            })
          : ''
      }
      description2={
        cert.description2
          ? intl.formatMessage({
              id: cert.description2,
              defaultMessage: cert.description2,
            })
          : ''
      }
      name={cert.name ? intl.formatMessage({ id: cert.name, defaultMessage: cert.name }) : ''}
      materials={cert.materials as string[]}
      signedBy={cert.signedBy}
      date={cert.date}
      loading={loading}
    />
  )
}

export default CertificateItem
